<template>
  <div>
    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <image-activity
        :toolbar-title="title"
        :tasks="tasks"
        :upload-to-mifos="uploadToMifos"
        :directory="directory"
        :entity-type="entityType"
        :entity-id="clientId"
        :attach-document-description="attachDocumentDescription"
        :attach-document-button-text="attachDocumentButtonText"
        :image-activity-type="imageActivityType"
        :document-preview-description="documentPreviewDescription"
        :reattach-document-text="reattachDocumentText"
        :identifier-required="true"
        identifier-label="PAN ID"
        :identifier="panNumber"
        :document-attached="documentAttached"
        @onPanDocumentUploaded="onPanDocumentUploaded"
        @uploadFailed="loading=false">
    </image-activity>

    <wxc-button
        v-if="false"
        text="Skip"
        type="blue"
        @wxcButtonClicked="skipUpload"
    ></wxc-button>
  </div>
</template>

<script>
import ImageActivity from "./ImageActivity";
import {Constants} from "@/components/Constants";
import WxcButton from "@/../weex-ui/packages/wxc-button/index";
import clientIdentifierUtility from "../../../utils/ClientIdentifierUtility";
import dataSource from "../../../data/DataSource";
import alertService from "../../core/alert/AlertService";
import EzUtils from "../../../utils/EzUtils";
import ImageUtils from "../../../utils/ImageUtils";
import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import LoanTaskActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import Loading from "../../layout/Loading";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import ErrorAlertItem from "@/components/layout/ErrorAlertItem";
import PrefManager from "@/data/model/PrefManager";
import {RolesConstants} from "@/utils/RolesConstants";

export default {
  name: "PanCardActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    ImageActivity,
    WxcButton,
    Loading
  },
  data: () => ({
    title: "Pan Image",
    identifier: {},
    createNewIdentifier: true,
    clientIdentifierId: 0,
    identifierImageExist: false,
    document: null,
    panImageFound: false,
    clientImageUrl: "",
    panNumber: "",
    documentAttached: false,
    fileName: "",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    clientId: LoanScopeDataHolder.getClientId()
  }),

  methods: {
    onPanIdentifierFound(identifier) {
      this.identifier = identifier;
      this.panNumber = identifier.documentKey;
      this.createNewIdentifier = false;
      this.clientIdentifierId = identifier.id;
      dataSource.getDocuments(Constants.CLIENTS, LoanScopeDataHolder.getClientId())
      .then(documentData => {
        if (documentData.errorOccurred) {
          alertService.alert({message: documentData.data})
        } else {
          let documents = documentData.data;
          const panDocuments = documents.filter(document =>
              document.name != null &&
              Constants.PAN_IMAGE_NAME.toLowerCase() === document.name.toLowerCase()
          );
          if (EzUtils.isNotEmpty(panDocuments)) {
            this.onPanDocumentFound(panDocuments[panDocuments.length - 1])
          }
        }
      })
    },

    onPanDocumentFound(panDocument) {
      this.panImageFound = true;
      this.documentAttached = true
      if (panDocument != null) {
        ImageUtils.getClientImageUrl(LoanScopeDataHolder.getClientId(), panDocument.id)
        .then(url => {
          this.clientImageUrl = url
        });
        if (this.document == null || this.document.id === 0) {
          this.document = panDocument;
        }
      }
    },

    onPanDataFound(identifier, document) {
      this.document = document;
      this.onPanIdentifierFound(identifier);
      this.identifierImageExist = true;
    },

    processPanData() {
      return (this.document != null && this.document.id !== 0)
    },

    skipUpload() {
      if (this.document.parentEntityId === LoanScopeDataHolder.getClientId()) {
        this.createDocumentLocationForIdentifier()
        .then(res => {
          this.getNextTask()
        })
      } else {
        this.getNextTask();
      }
    },

    getNextTask() {
      this.loading = true;
      LoanTaskActivityNavigator.getNextTask(this.tasks)
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.networkError = res.data;
          this.errorAlertEvent = true;
        }
      });
    },

    createDocumentLocationForIdentifier() {
      return dataSource.createDocumentLocation(
          "client_identifiers",
          this.clientIdentifierId,
          Constants.PAN_IMAGE_NAME.toLowerCase(),
          Constants.getDescription(Constants.PAN_IMAGE_NAME),
          this.document.fileName,
          this.document.location
      )
    },

    createDocumentLocationForIdentifiers(clientId, clientIdentifierId) {
      dataSource.createDocumentLocation(Constants.CLIENTS, clientId,
          this.directory.toUpperCase(),
          Constants.getDescription(this.directory), this.fileName, this.getAwsPath())
      .then(res => {
        dataSource.createDocumentLocation("client_identifiers", clientIdentifierId,
            this.directory.toLowerCase(),
            Constants.getDescription(this.directory), this.fileName,
            this.getAwsPath()).then(res => {
          this.getNextTask()
        })
      })
    },

    onPanDocumentUploaded(event) {
      console.log("see here")
      console.log(event.identifier)
      this.identifier = event.identifier;
      this.fileName = event.fileName;
      if (this.createNewIdentifier) {
        dataSource.createClientIdentifierUsingMifos(LoanScopeDataHolder.getClientId(),
            {"documentType": "PAN", "description": "Pan Card"}, event.identifier)
        .then(res => {
          this.createDocumentLocationForIdentifiers(LoanScopeDataHolder.getClientId(),
              res.data.resourceId)
        }).then(res => {
          this.getNextTask();
        })
      } else if (!this.identifierImageExist) {
        this.createDocumentLocationForIdentifiers(LoanScopeDataHolder.getClientId(),
            this.clientIdentifierId)
      }
    },

    getAwsPath() {
      return "documents" + "/"
          + this.entityType + "/"
          + LoanScopeDataHolder.getClientId() + "/"
          + this.directory + "/" + this.directory.toUpperCase();
    },

    fetchInitialData() {
      clientIdentifierUtility.getClientIdentifier(LoanScopeDataHolder.getClientId(),
          {"documentType": "PAN", "description": "Pan Card"})
      .then(identifier => {
        if (identifier.errorOccurred) {
          alertService.alert({message: identifier})
        } else {
          dataSource.getDocuments("client_identifiers", identifier.id)
          .then(documents => {
            if (identifier.errorOccurred) {
              this.onPanIdentifierFound(identifier)
            } else {
              if (EzUtils.isEmpty(documents.data)) {
                this.onPanIdentifierFound(identifier)
              } else {
                this.onPanDataFound(identifier, documents.data[0])
              }
            }
          })
        }
      })
    }
  },

  created: function () {
    this.fetchInitialData()
  },

  computed: {
    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    /* activity-redirect-item props START*/
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PAN_ADDED];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name
          : "";
    },
    /* activity-redirect-item props END*/

    /*Image screen props START*/
    uploadToMifos() {
      return Constants.DO_NOT_UPLOAD;
    },

    directory() {
      return Constants.PAN_IMAGE_NAME;
    },

    entityType() {
      return Constants.CLIENTS;
    },

    entityId() {
      return LoanScopeDataHolder.getClientId();
    },

    attachDocumentTitle() {
      return this.isAgent ? "Please take a Customer's Selfie" : "Please take a Selfie";
    },

    attachDocumentDescription() {
      return "Upload PAN Card Copy.";
    },

    attachDocumentButtonText() {
      return "Attach Pan Card";
    },

    reattachDocumentText() {
      return "Reattach Pan Card";
    },

    documentPreviewDescription() {
      return "Preview Pan Card";
    },

    imageActivityType() {
      return Constants.PAN_IMAGE_IMAGE_ACTIVITY;
    }
    /*Image screen props END*/
  }
};
</script>

<style scoped>

</style>
